/**
 * Degrades d'avatar des ecrans d'appel (maquette « Ecrans d'appel Konbit POS v2 ») : les
 * quatre teintes qu'elle emploie, choisies par une empreinte stable du nom — la meme
 * personne garde la meme couleur d'un ecran a l'autre.
 */
const DEGRADES = [
    'linear-gradient(150deg,#a5b4fc,#4f46e5)',
    'linear-gradient(150deg,#fb7185,#e11d48)',
    'linear-gradient(150deg,#34d399,#059669)',
    'linear-gradient(150deg,#818cf8,#4f46e5)',
] as const;

export function degradeAvatar(cle: string | number): string {
    const texte = String(cle);
    let h = 0;
    for (let i = 0; i < texte.length; i++) h = (h * 31 + texte.charCodeAt(i)) >>> 0;
    return DEGRADES[h % DEGRADES.length];
}

/** Initiale affichee dans l'avatar : la premiere lettre du nom, en majuscule. */
export function initiale(nom: string): string {
    return (nom.trim().charAt(0) || '?').toUpperCase();
}

/**
 * La photo de profil, si c'en est une : une URL (http, https, data) ou un chemin absolu. Le champ
 * `avatar` d'un profil peut aussi contenir des initiales — jamais a afficher comme image.
 */
export function urlPhoto(valeur: string | null | undefined): string | undefined {
    const v = (valeur ?? '').trim();
    return /^(https?:\/\/|data:image\/|\/)/i.test(v) ? v : undefined;
}

/** Fonds sombres des tuiles de la grille de groupe (maquette `GroupGrid`) : un par teinte d'avatar. */
const FONDS_TUILE = [
    'linear-gradient(160deg,#2a2472 0%,#181346 55%,#0c0a22 100%)',
    'linear-gradient(160deg,#4c1d2e 0%,#2c1220 55%,#150a10 100%)',
    'linear-gradient(160deg,#0f3d34 0%,#0a2620 55%,#051512 100%)',
    'linear-gradient(160deg,#2a2472 0%,#181346 55%,#0c0a22 100%)',
] as const;

/** Fond de tuile assorti a l'avatar de la meme personne. */
export function fondTuile(cle: string | number): string {
    return FONDS_TUILE[(DEGRADES as readonly string[]).indexOf(degradeAvatar(cle))];
}
